import http from "../httpService";
import { apiUrl } from "../../../config.js";
import { DateTime } from "luxon";
const apiEndpoint = apiUrl + "/users/user-report/";

export function getUserDashboard(fiscalYearID = 0, fiscalPeriodID = 0) {
  return http.get(
    apiEndpoint + "user-dashboard/" + fiscalYearID + "/" + fiscalPeriodID
  );
}

export function getActiveUserSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "active-user-summary/" + fiscalYearID);
}

export function getAverageTimeSpentSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "average-time-spent-summary/" + fiscalYearID);
}

export function getUserActionsSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "user-actions-summary/" + fiscalYearID);
}

export function getSignInDeviceSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "signin-device-summary/" + fiscalYearID);
}

export function getUserActiveStatusReport() {
  return http.get(apiEndpoint + "user-active-status-report");
}

export function getUserSessionReport() {
  return http.get(apiEndpoint + "user-session-report");
}

export function getUserLockReport() {
  return http.get(apiEndpoint + "user-lock-report");
}

export function getMailChannelLogReport(
  dateFrom = DateTime.now().startOf("day"),
  dateTo = DateTime.now().endOf("day")
) {
  return http.get(
    apiEndpoint + `mail-channel-log-report/${dateFrom}/${dateTo}`
  );
}
